import { AgrLoginTypes, IETFLocales, SignupSigninPolicy } from '@next/core-lib/environment';

import { Environment } from './environment.model';

export { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'Shop',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: '82c898ca-bc2d-4ce1-9ce0-c635fd17cbf0',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2cdev.b2clogin.com/tfp/agrifirmb2cdev.onmicrosoft.com/',
  APPLICATION_KEY: 'Cart',
  AUTHORIZED_BY: {},
  APP_INSIGHTS_KEY: '',
  DEFAULT_LOCALE: IETFLocales.nl,
  LOCALES: [IETFLocales.nl, IETFLocales.en, IETFLocales.pl, IETFLocales.fr, IETFLocales.de],
  PRODUCTION: false,
  MY_OFFICE_URL: 'https://to-my.c4htest.mcps.agrifirm.com',
  RELATIONSHIPS_ELASTIC_SEARCH: true,
  CUSTOMER_IN_LOCATION_SELECTOR: true,
  MSAL_LOGGING: false,
  NGRX_LOGGING: false,
  ERROR_PAGE_HOME_BUTTON: true,
  ERROR_PAGE_BACK_BUTTON: true,
  SHOP_URL: 'http://localhost:4200',
  IDENTIFICATION_TYPES_NL: ['ZCPNL1', 'ZEPEU1', 'ZMONL1', 'ZRONL1'],
  INSTANT_ORDER: true,
  DELIVERY_TIME_WINDOW_DISABLED: true,
  SHOW_CART_ICON: true,
  SHOW_DISABLED_LOCATION_BADGE: true,
  APIM_BASE_URL: 'http://localhost:4200/external',
  SUBSCRIBE_TO_CART_EVENTS: true,
  IS_MY_PROSPECTS_HIDDEN: true,
  ARE_ORDER_BLOCKED_LOCATIONS_HIDDEN: true,
  IDENTIFICATION_WARNING_PERIOD: 'P21D',
  KUBE_CONTAINER_NAME: '',
  KUBE_NODE_NAME: '',
  KUBE_POD_NAME: '',
  KUBE_TEAM: '',
};
